import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { LinkButton } from "@/globalComponents/atoms/Button"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"
import { useTheme } from "@/utilities/hooks/useTheme"

// @ts-ignore - Route generation issue with TanStack Router
export const Route = createFileRoute("/auth/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { qrLookupID, redirect } = Route.useSearch()
  const { t } = useTranslation()

  const locationName =
    useTheme().scannedArea?.theme.locationInformation.locationName

  return (
    <>
      <Heading level={1} as={1}>
        {t("auth.index.heading")}
      </Heading>
      <Text level={2} style={{ marginTop: "var(--space-2)" }}>
        {locationName
          ? t(
              "auth.index.descriptionWithLocation",
              "To accelerate your future visits at {{locationName}}, create a new Inflow account or sign into an existing one.",
              { locationName }
            )
          : t(
              "auth.index.descriptionGeneric",
              "Create a new Inflow account or sign into an existing one for fast, frictionless parking."
            )}
      </Text>
      <div>
        <LinkButton
          hue="secondary"
          variant="default"
          to="/auth/create-account"
          search={{ qrLookupID, redirect }}
          style={{ marginBottom: "var(--space-3)" }}
        >
          {t("auth.index.createAccount", "Create account")}
        </LinkButton>
        <LinkButton
          hue="neutral"
          variant="default"
          to="/auth/sign-in"
          search={{ qrLookupID, redirect }}
        >
          {t("auth.index.signIn", "Sign in")}
        </LinkButton>
      </div>

      {/*
        TODO: Need this to be conditional based on if the user is being
        directed here as part of the register process or not

        <Text level={2}>
          <LinkButton
            hue="primary"
            presentation="link"
            to="/"
            search={qrLookupID ? { qrLookupID } : {}}
          >
            {t("auth.index.skipForNow", "Skip for now")}
          </LinkButton>
        </Text> */}
    </>
  )
}
